import React, { useEffect, useState } from 'react';
import {
  Button,
  Paper,
  Grid,
  Avatar,
  TextField,
  CardHeader,
  Typography,
  Box,
} from '@material-ui/core';
import { useStyles } from './style';
import DoctariModal from '../../components/Modal';
import {
  DropzoneArea,
} from 'material-ui-dropzone';
import { connect } from 'react-redux';
import { APPOINTMENTS } from '../../utils/urls';
import { userActionsTypes } from '../../redux/user/actions';
import {
  appointmentActionsTypes,
} from '../../redux/appointment/actions';
import AutocompleteInfo from '../../components/AutocompleteInfo';
import { useHistory, useLocation } from 'react-router';
import moment from 'moment';
import { AttachmentList } from './AttachmentList';
import Autocomplete from '@material-ui/lab/Autocomplete';

import {
  diabetes_type_options,
  physical_activity_level,
  exercise_type_options,
  yes_no_options,
  in_diet_options,
  makes_carbohydrates_count_options,
  had_educative_sessions_options,
  diabetes_care_understanding_options,
  psycological_evaluation_options,
  stress_level_options,
  psycological_support_options,
} from '../../utils/appointmentFieldOptions';

function AppointmentDetails({
  getUser,
  createAppointment,
  appointmentsData,
  session,
  userData,
  addUserInfo,
  deleteUserInfo,
  createInfo,
  deleteAppointment,
  updateAppointment,
  uploadAppointmentFiles,
  deleteAppointmentFile,
  deleteAttachmentMessages,
  updateAppointmentLight,
  getAppointmentPDF,
  getAppointmentConsentFile,
}) {
  const history = useHistory();
  const location = useLocation();
  const styles = useStyles();
  const [buttonClicked, setButtonClicked] = useState(false);
  const isProfessional = session.userType == 'doctor';
  const isPatient = session.userType == 'patient';
  const appointment = location.state.appointment;
  const isAppointmentLight = appointment.is_light;
  const [attachmentModalOpen, setAttachmentModalOpen] = useState(false);
  const [seeAttachmentsModalOpen, setSeeAttachmentsModalOpen] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [input, setInput] = useState(appointment.patient_appointment_reason);
  const [files, setFiles] = useState(appointment.files);
  const isAssistant = session.userType == 'assistant';
  const [doctorFullData, setDoctorFullData] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  const isDone = appointment.is_done;
  const [cancelAppointmentModal, setCancelAppointmentModal] = useState(false);
  const [feedback, setFeedback] = useState('');

  const [injuredArea, setInjuredArea] = useState(appointment.injured_area);
  const [physicalExamination, setPhysicalExamination] = useState(appointment.physical_examination);

  const [symptoms, setSymptoms] = useState(appointment.symptoms);
  const [symptomsTime, setSymptomsTime] = useState(appointment.symptoms_time);
  const [spo2, setSpo2] = useState(appointment.spo2);
  const [glucose, setGlucose] = useState(appointment.glucose);
  const [systolicPressure, setSystolicPressure] = useState(appointment.systolic_pressure);
  const [diastolicPressure, setDiastolicPressure] = useState(appointment.diastolic_pressure);
  const [heartRate, setHeartRate] = useState(appointment.heart_rate);
  const [temperature, setTemperature] = useState(appointment.temperature);


  useEffect(() => {
    if (appointmentsData.success.uploadFiles) {
      files.push(...appointmentsData.success.uploadFiles);
      setFiles(files);
      setAttachmentModalOpen(false);
    }
    return () => deleteAttachmentMessages(true);
  }, [appointmentsData.success.uploadFiles]);

  useEffect(() => {
    if (
      ((appointmentsData.success.genericMessage &&
        appointmentsData.success.genericMessage ==
        'Appointment eliminado con exito') ||
        appointmentsData.success.genericMessage ==
        'Appointment actualizado con exito') &&
      buttonClicked
    ) {
      history.push(APPOINTMENTS);
    }
  }, [appointmentsData.success.genericMessage]);

  useEffect(() => {
    getUser(session.userType, session.id);
  }, []);

  useEffect(() => {
    if (userData.user) {
      setUserLoading(false);
    }
  }, [userData.user]);

  const { user, medications, allergies, diseases } = userData;

  const getUrlAndId = (type, isForDelete) => {
    let dataType = {};
    if (type === 'medications') {
      dataType = {
        id: 'medication_id',
        url: isForDelete ? 'delete_medication' : 'patient_medication',
      };
    } else if (type === 'diseases') {
      dataType = {
        id: 'disease_id',
        url: isForDelete ? 'delete_disease' : 'patient_disease',
      };
    } else if (type === 'allergies') {
      dataType = {
        id: 'allergie_id',
        url: isForDelete ? 'delete_allergie' : 'patient_allergie',
      };
    }
    return dataType;
  };

  const handleUserMedication = (isNew, med, isForDelete = false) => {
    const infoToUpdate = 'medications';
    const data = getUrlAndId(infoToUpdate, isForDelete);
    if (!isForDelete) {
      if (isNew) {
        createInfo(infoToUpdate, { name: med.name }, data);
      } else {
        addUserInfo(infoToUpdate, data, med);
      }
    } else {
      deleteUserInfo(infoToUpdate, data, med.id);
    }
  };

  const handleUserDisease = (isNew, disease, isForDelete = false) => {
    const infoToUpdate = 'diseases';
    const data = getUrlAndId(infoToUpdate, isForDelete);
    if (!isForDelete) {
      if (isNew) {
        createInfo(infoToUpdate, { name: disease.name }, data);
      } else {
        addUserInfo(infoToUpdate, data, disease);
      }
    } else {
      deleteUserInfo(infoToUpdate, data, disease.id);
    }
  };

  const handleUserAllergie = (isNew, allergie, isForDelete = false) => {
    const infoToUpdate = 'allergies';
    const data = getUrlAndId(infoToUpdate, isForDelete);
    if (!isForDelete) {
      if (isNew) {
        createInfo(infoToUpdate, { name: allergie.name }, data);
      } else {
        addUserInfo(infoToUpdate, data, allergie);
      }
    } else {
      deleteUserInfo(infoToUpdate, data, allergie.id);
    }
  };

  const addInformation = {
    handleUserMedication,
    handleUserAllergie,
    handleUserDisease,
  };

  const handleAttachmentsChange = (files) => {
    setAttachments(files);
    console.log(attachments);
    console.log(files);
  };

  const handleUploadAttachments = () => {
    const formDataAppointment = new FormData();
    for (let i = 0; i < attachments.length; i++) {
      console.log(`file${i}`);
      formDataAppointment.append(`file${i}`, attachments[i]);
    }
    const body = {
      files: formDataAppointment,
      appointmentId: appointment.id,
    };
    uploadAppointmentFiles(body);
    setAttachments([]);
  };

  const handleCancelUploadAttachments = () => {
    setAttachments([]);
    setAttachmentModalOpen(false);
  }

  const handleInjuredAreaChange = (e) => {
    setInjuredArea(e.target.value);
    console.log(e.target.value);
  };

  const handlePhysicalExaminationChange = (e) => {
    setPhysicalExamination(e.target.value);
    console.log(e.target.value);
  };

  const handleSymptomsChange = (e) => {
    setSymptoms(e.target.value);
    console.log(e.target.value);
  };

  const handleSymptomsTimeChange = (e) => {
    setSymptomsTime(e.target.value);
    console.log(e.target.value);
  };

  const handleSpo2Change = (e) => {
    setSpo2(e.target.value);
    console.log(e.target.value);
  };

  const handleGlucoseChange = (e) => {
    setGlucose(e.target.value);
    console.log(e.target.value);
  };

  const handleSystolicPressureChange = (e) => {
    setSystolicPressure(e.target.value);
    console.log(e.target.value);
  };

  const handleDiastolicPressureChange = (e) => {
    setDiastolicPressure(e.target.value);
    console.log(e.target.value);
  };

  const handleHeartRateChange = (e) => {
    setHeartRate(e.target.value);
    console.log(e.target.value);
  };

  const handleTemperatureChange = (e) => {
    setTemperature(e.target.value);
    console.log(e.target.value);
  };

  const handleInputCHange = (e) => {
    setInput(e.target.value);
    console.log(e.target.value);
  };
  const handleDeleteAppointment = () => {
    setButtonClicked(true);
    deleteAppointment(appointment.id);
  };

  const handleUpdateAppointment = () => {
    setButtonClicked(true);
    let body = {
      appointmentId: appointment.id,
      patient_appointment_reason: input,
      diseases: user.diseases,
      medications: user.medications,
      allergies: user.allergies,
      injured_area: injuredArea,
      physical_examination: physicalExamination,
      symptoms,
      symptoms_time: symptomsTime,
      spo2: spo2,
      glucose: glucose,
      systolic_pressure: systolicPressure,
      diastolic_pressure: diastolicPressure,
      heart_rate: heartRate,
      temperature: temperature,
      isInformation: true,
    };
    updateAppointment(body);
  };

  const handleChangeDoctor = (e, value) => {
    console.log('ESTE ES EL DOCTOR EN HANDLE ', value);
    if (value == null) {
      // console.log('este valor es null en handle');
      // clearSelectDoctor();
      // clearSchedules();
      setDoctorFullData(null);
      // console.log('seguro no es cero pero ', appointmentsData.schedules);
    } else {
      setDoctorFullData(value);
    }
  };

  const handleCancelAppointment = (e) => {
    e.preventDefault();
    setButtonClicked(true);
    let body = {
      status: 'cancelled',
      is_cancelled: true,
      cancellation_reason: feedback,
      isInformation: false,
    };
    if (appointment.is_light) {
      updateAppointmentLight(appointment.id, body);
    } else {
      body['appointmentId'] = appointment.id;
      updateAppointment(body);
    }
  };

  const handleDownloadAppointmentDetails = () => {
    const appointmentDate = moment(appointment.date)
      .tz(moment.tz.guess())
      .format('YYYY_MM_DD_HH:mm[hs]')

    getAppointmentPDF(appointment.id, appointmentDate)
  }

  const handleDownloadAppointmentConsentFile = () => {
    const appointmentDate = moment(appointment.date)
      .tz(moment.tz.guess())
      .format('YYYY_MM_DD_HH:mm[hs]')

    getAppointmentConsentFile(appointment.id, appointmentDate)
  }

  const genericDoctariFormFields = <>
    {isAssistant && (
      <Grid
        // container
        // direction="row"
        item
        xs={12}
        md={12}
      // style={{ padding: '1rem 0 0 3rem' }}
      >
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={
            !userLoading
              ? userData.user.doctors.filter((doctor) => {
                return doctor.is_active;
              })
              : []
          }
          getOptionLabel={(option) => option.full_name}
          sx={{ width: 300 }}
          value={doctorFullData}
          onChange={handleChangeDoctor}
          renderInput={(params) => (
            <TextField {...params} label="Seleccione un doctor" />
          )}
        />
      </Grid>
    )}
    <Grid item md={12} xs={12}>
      <TextField
        disabled={isProfessional || isPatient ||  isAssistant || isDone}
        required
        id="standard-basic"
        label="Motivo de la consulta"
        variant="standard"
        style={{ width: '100%' }}
        className={styles.paperGridItems}
        onChange={handleInputCHange}
        defaultValue={appointment.patient_appointment_reason}
      />
    </Grid>
    <Grid item md={6} xs={12} className={styles.paperGridItems}>
      <AutocompleteInfo
        label={'Alergias'}
        optionList={allergies}
        valuesSelected={
          isProfessional || isAssistant
            ? appointment.allergies
            : user
              ? user.allergies
              : []
        }
        isProfessional={isProfessional}
        setNewValue={(allergie) => {
          const isNew = true;
          if (!isPatient)
            addInformation.handleUserAllergie(isNew, allergie);
        }}
        addValue={(allergie) => {
          const isNew = false;
          if (!isPatient)
            addInformation.handleUserAllergie(isNew, allergie);
        }}
        deleteValue={(allergie) => {
          const isNew = false;
          const isForDelete = true;
          if (!isPatient)
            addInformation.handleUserAllergie(
              isNew,
              allergie,
              isForDelete
            );
        }}
        isAssistant={isAssistant}
      />
    </Grid>
    <Grid item md={6} xs={12} className={styles.paperGridItems}>
      <AutocompleteInfo
        label={'Enfermedades'}
        optionList={diseases}
        valuesSelected={
          isProfessional || isAssistant
            ? appointment.diseases
            : user
              ? user.diseases
              : []
        }
        isProfessional={isProfessional}
        setNewValue={(disease) => {
          const isNew = true;
          if (!isPatient)
            addInformation.handleUserDisease(isNew, disease);
        }}
        addValue={(disease) => {
          const isNew = false;
          if (!isPatient)
            addInformation.handleUserDisease(isNew, disease);
        }}
        deleteValue={(disease) => {
          const isNew = false;
          const isForDelete = true;
          if (!isPatient)
            addInformation.handleUserDisease(
              isNew,
              disease,
              isForDelete
            );
        }}
        isAssistant={isAssistant}
      />
    </Grid>
    <Grid item md={6} xs={12} className={styles.paperGridItems}>
      <AutocompleteInfo
        label={'Medicamentos'}
        optionList={medications}
        valuesSelected={
          isProfessional || isAssistant
            ? appointment.medications
            : user
              ? user.medications
              : []
        }
        isProfessional={isProfessional}
        setNewValue={(med) => {
          const isNew = true;
          if (!isPatient)
            addInformation.handleUserMedication(isNew, med);
        }}
        addValue={(med) => {
          const isNew = false;
          if (!isPatient)
            addInformation.handleUserMedication(isNew, med);
        }}
        deleteValue={(med) => {
          const isNew = false;
          const isForDelete = true;
          if (!isPatient)
            addInformation.handleUserMedication(
              isNew,
              med,
              isForDelete
            );
        }}
        isAssistant={isAssistant}
      />
    </Grid>

    {(isProfessional || isPatient || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isPatient || isAssistant || isDone}
          id='standard-basic'
          label='Lesión'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleInjuredAreaChange}
          defaultValue={appointment.injured_area}
        />
      </Grid>
    }

    {(isProfessional || isPatient || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isPatient || isAssistant || isDone}
          id="standard-basic"
          label='Examen físico'
          variant="standard"
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handlePhysicalExaminationChange}
          defaultValue={appointment.physical_examination}
        />
      </Grid>
    }

    {(isProfessional || isPatient || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isPatient || isAssistant || isDone}
          id='standard-basic'
          label='Síntomas'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.symptoms}
        />
      </Grid>
    }

    {(isProfessional || isPatient || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isPatient || isAssistant || isDone}
          id='standard-basic'
          label='Tiempo de los síntomas'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsTimeChange}
          defaultValue={appointment.symptoms_time}
        />
      </Grid>
    }

    {(isProfessional || isPatient || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isPatient || isAssistant || isDone}
          id='standard-basic'
          label='SPO2 (%)'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSpo2Change}
          defaultValue={appointment.spo2}
        />
      </Grid>
    }

    {(isProfessional || isPatient || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isPatient || isAssistant || isDone}
          id='standard-basic'
          label='Glucosa en sangre (mg/dl)'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleGlucoseChange}
          defaultValue={appointment.glucose}
        />
      </Grid>
    }

    {(isProfessional || isPatient || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isPatient || isAssistant || isDone}
          id='standard-basic'
          label='Presión Sistólica (mm Hg)'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSystolicPressureChange}
          defaultValue={appointment.systolic_pressure}
        />
      </Grid>
    }

    {(isProfessional || isPatient || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isPatient || isAssistant || isDone}
          id='standard-basic'
          label='Presión Diástolica (mm Hg)'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleDiastolicPressureChange}
          defaultValue={appointment.diastolic_pressure}
        />
      </Grid>
    }

    {(isProfessional || isPatient || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isPatient || isAssistant || isDone}
          id='standard-basic'
          label='Frecuencia Cardíaca (ppm)'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleHeartRateChange}
          defaultValue={appointment.heart_rate}
        />
      </Grid>
    }

    {(isProfessional || isPatient || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isPatient || isAssistant || isDone}
          id='standard-basic'
          label='Temperatura (°C)'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleTemperatureChange}
          defaultValue={appointment.temperature}
        />
      </Grid>
    }
  </>

  const ADUFormFields = <>
    <Grid item md={12} xs={12}>
      <TextField
        disabled={isProfessional || isAssistant || isDone}
        required
        id="standard-basic"
        label="Motivo de la consulta"
        variant="standard"
        style={{ width: '100%' }}
        className={styles.paperGridItems}
        onChange={handleInputCHange}
        defaultValue={appointment.patient_appointment_reason}
      />
    </Grid>

    <Grid className={styles.firstPaperContainer}>
      <b>Datos Personales:</b>
    </Grid>

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={12} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Nombre del Paciente'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleInjuredAreaChange}
          defaultValue={appointment.patient.full_name}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id="standard-basic"
          label='Fecha de Nacimiento'
          variant="standard"
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handlePhysicalExaminationChange}
          defaultValue={appointment.patient.date_of_birth}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id="standard-basic"
          label='Fecha de Ingreso a la Organización'
          variant="standard"
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handlePhysicalExaminationChange}
          defaultValue={appointment.patient.date_of_enrollment}
        />
      </Grid>
    }

    <Grid className={styles.firstPaperContainer}>
      <b>Datos de Contacto:</b>
    </Grid>

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Teléfono'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.telephone}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Correo Electrónico'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.email}
        />
      </Grid>
    }

    <Grid className={styles.firstPaperContainer}>
      <b>Antecedentes Médicos:</b>
    </Grid>

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Fecha de Diagnóstico'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.date_of_diagnosis}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label="Diabetes Tipo"
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={diabetes_type_options[appointment.patient.diabetes_type]}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Tratamiento Actual'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.current_treatment}
        />
      </Grid>
    }

    <Grid className={styles.firstPaperContainer}>
      <b>Historial de Glucosa:</b>
    </Grid>

    {(isProfessional || isPatient || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Hemoglobina A1c más reciente'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.recent_A1c_hemoglobin}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Tiempo en rango si utiliza monitoreo Flash o continuo'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.time_within_range_with_flash_or_continuum}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Tiempo en rango'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.time_within_range}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Tiempo debajo del rango'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.time_under_range}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Tiempo por encima del rango'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.time_over_range}
        />
      </Grid>
    }

    <Grid className={styles.firstPaperContainer}>
      <b>Medicación Actual:</b>
    </Grid>


    <Grid item md={6} xs={12} className={styles.paperGridItems}>
      <AutocompleteInfo
        label={'Medicamentos'}
        optionList={medications}
        valuesSelected={
          isProfessional || isAssistant
            ? appointment.medications
            : user
              ? user.medications
              : []
        }
        isProfessional={isProfessional}
        setNewValue={(med) => {
          const isNew = true;
          addInformation.handleUserMedication(isNew, med);
        }}
        addValue={(med) => {
          const isNew = false;
          addInformation.handleUserMedication(isNew, med);
        }}
        deleteValue={(med) => {
          const isNew = false;
          const isForDelete = true;
          addInformation.handleUserMedication(
            isNew,
            med,
            isForDelete
          );
        }}
        isAssistant={isAssistant}
      />
    </Grid>

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Dosis'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.dosis}
        />
      </Grid>
    }

    <Grid className={styles.firstPaperContainer}>
      <b>Historial de Actividad Física:</b>
    </Grid>

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label="Nivel de Actividad Física"
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={physical_activity_level[appointment.patient.physical_activity_level]}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label="Tipo de Ejercicio"
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={exercise_type_options[appointment.patient.exercise_type]}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Frecuencia semanal'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.weekly_frecuency}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Duración de sesión en mins'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.session_time_in_minutes}
        />
      </Grid>
    }

    <Grid className={styles.firstPaperContainer}>
      <b>Estado Nutricional:</b>
    </Grid>

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label="Realiza alguna dieta en particular"
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={in_diet_options[appointment.patient.in_diet]}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Peso'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.weight}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Talla'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.height}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Peso/Edad (Desde el nacimiento hasta los 2 años)'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.weight_age_ratio}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Peso/Talla (Desde los 2 años hasta los 5 años)'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.weight_height_ratio}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='IMC/Edad (Desde los 5 años hasta los 15 años)'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.imc_age_ratio}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Valoración del estado nutricional'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.nutritional_state}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Requerimiento Energetico Diario'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.daily_energy_requirement}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Carbohidratos'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.carbohidrates}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Proteinas'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.proteins}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Grasas'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.fats}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label="Realiza Conteo de Carbohidratos"
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={makes_carbohydrates_count_options[appointment.patient.makes_carbohydrates_count]}
        />
      </Grid>
    }

    <Grid className={styles.firstPaperContainer}>
      <b>Educación y Prevención:</b>
    </Grid>

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label="Ha participado de sesiones educativas en diabetes"
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={had_educative_sessions_options[appointment.patient.had_educative_sessions]}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label="Nivel de comprensión del cuidado de la diabetes"
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={diabetes_care_understanding_options[appointment.patient.diabetes_care_understanding]}
        />
      </Grid>
    }

    <Grid className={styles.firstPaperContainer}>
      <b>Cuidado de los Pies:</b>
    </Grid>

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Revisiones Podológicas'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.podological_reviews}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Cuidados Diarios'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.podological_daily_care}
        />
      </Grid>
    }

    <Grid className={styles.firstPaperContainer}>
      <b>Salud Mental:</b>
    </Grid>

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label="Evaluación Psicológica"
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={psycological_evaluation_options[appointment.patient.psycological_evaluation]}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label="Nivel de Estrés"
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={stress_level_options[appointment.patient.stress_level]}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label="Apoyo Psicológico"
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={psycological_support_options[appointment.patient.psycological_support]}
        />
      </Grid>
    }

    <Grid className={styles.firstPaperContainer}>
      <b>Recomendaciones</b>
    </Grid>

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Objetivos de Control de Glucosa'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.glucose_target}
        />
      </Grid>
    }

    {(isProfessional || isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          label='Cambios en el Estilo de Vida'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.lifestyle_changes}
        />
      </Grid>
    }

    <Grid className={styles.firstPaperContainer}>
      <b>Notas</b>
    </Grid>

    {(isProfessional && isAppointmentLight) &&
      <Grid item md={6} xs={12}>
        <TextField
          disabled={isProfessional || isAssistant || isDone}
          id='standard-basic'
          // label='Notas'
          variant='standard'
          style={{ width: '100%' }}
          className={styles.paperGridItems}
          onChange={handleSymptomsChange}
          defaultValue={appointment.patient.medical_notes}
        />
      </Grid>
    }

  </>

  return (
    <>
      {/* Add files modal */}
      <DoctariModal
        open={attachmentModalOpen}
        setOpen={(val) => setAttachmentModalOpen(val)}
        title={'Adjuntar estudios'}
      >
        <DropzoneArea
          useChipsForPreview={true}
          dropzoneText={
            'Haz click aquí o arrastra tus archivos para adjuntarlos'
          }
          onChange={(files) => handleAttachmentsChange(files)}
          onDelete={(file) => console.log(file)}
          clearOnUnmount={false}
          filesLimit={3}
          initialFiles={attachments}
          getFileAddedMessage={(file) => `${file} añadido`}
          getFileRemovedMessage={(file) => `${file} eliminado`}
          getFileLimitExceedMessage={(limit) =>
            `Limite de archivos excedido, el limite es de ${limit} archivos`
          }
        />
        <Button
          style={{ float: 'right', margin: '10px' }}
          variant="contained"
          color="primary"
          disabled={!attachments.length}
          onClick={handleUploadAttachments}
        >
          {!appointmentsData.loading ? 'Aceptar' : 'Cargando...'}
        </Button>
        <Button
          style={{ float: 'right', margin: '10px' }}
          color="red"
          onClick={handleCancelUploadAttachments}
          variant="outlined"
        /* color="primary" */
        >
          Cancelar
        </Button>
      </DoctariModal>
      {/* See files modal */}
      <DoctariModal
        open={seeAttachmentsModalOpen}
        setOpen={(val) => setSeeAttachmentsModalOpen(val)}
        title={'Archivos adjuntos'}
      >
        <AttachmentList
          files={files}
          setFiles={setFiles}
          deleteFile={deleteAppointmentFile}
        ></AttachmentList>
        <Button
          style={{ float: 'right', margin: '10px' }}
          variant="contained"
          color="primary"
          onClick={() => setSeeAttachmentsModalOpen(false)}
        >
          Aceptar
        </Button>
        <Button
          style={{ float: 'right', margin: '10px' }}
          color="red"
          onClick={() => setSeeAttachmentsModalOpen(false)}
          variant="outlined"
        /*  color="primary" */
        >
          Cancelar
        </Button>
      </DoctariModal>

      {/* Appointment's cancelation modal */}
      <DoctariModal
        open={cancelAppointmentModal}
        setOpen={(val) => setCancelAppointmentModal(val)}
        title={'Confirmación de cancelación'}
      >
        <Typography style={{ padding: '1rem' }}>
          ¿Estas seguro que deseas cancelar la consulta?
        </Typography>
        <form onSubmit={handleCancelAppointment}>
          <Box style={{ padding: '1rem' }}>
            <TextField
              required
              id="outlined-multiline-static"
              label="¿Por qué?"
              multiline
              style={{ width: '100%' }}
              rows="4"
              placeholder="Comentarios..."
              variant="outlined"
              onChange={(e) => setFeedback(e.target.value)}
            />
          </Box>
          <Box>
            <Button
              style={{ float: 'right', margin: '10px' }}
              variant="contained"
              color="primary"
              // disabled={!attachments.length}
              // onClick={() => }
              type="submit"
            >
              {!appointmentsData.loading ? 'Aceptar' : 'Cargando...'}
            </Button>

            <Button
              style={{ float: 'right', margin: '10px' }}
              color="red"
              onClick={() => {
                setCancelAppointmentModal(false);
              }}
              variant="outlined"
            /* color="primary" */
            >
              Cancelar
            </Button>
          </Box>
        </form>
      </DoctariModal>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          item
          xs={12}
          md={12}
          justifyContent="space-between"
          className={styles.menuContainer}
        >
          <h2 className={styles.title}>Detalles de la consulta</h2>
          <CardHeader
            avatar={
              <Avatar
                alt="Foto de perfil"
                src={
                  appointment.patient //TODO todos los chequeos de appointment.patient hay que sacarlos, quedaron appointment con patient= null por error, hay que limpiarlos
                    ? isProfessional
                      ? appointment.patient.profile_picture &&
                      appointment.patient.profile_picture.url
                      : appointment.doctor.profile_picture &&
                      appointment.doctor.profile_picture.url
                    : null
                }
                className={styles.avatar}
              />
            }
            title={
              isProfessional
                ? appointment.patient.full_name
                : appointment.doctor.full_name
            }
            subheader={
              isProfessional ? null : appointment.doctor.specialty.name
            }
          />
        </Grid>
        <Grid item className={styles.formConteiner}>
          <Paper elevation={8} style={{ padding: '40px 40px' }}>
            <Grid item container spacing={2} className={styles.testContainer}>
              <Grid className={styles.firstPaperContainer}>
                <p>
                  <b>Fecha de consulta:</b>
                  {` ${moment(appointment.date)
                    .tz(moment.tz.guess())
                    .format('YYYY-MM-DD HH:mm [hs]')}`}
                </p>
                <p>
                  Valor de la consulta:{' '}
                  <b>{appointment.price ? `$${appointment.price}` : '-'}</b>{' '}
                </p>
              </Grid>
              {
                process.env.REACT_APP_NAME === 'adu'
                  ? ADUFormFields
                  : genericDoctariFormFields
              }
            </Grid>

            <div className={styles.forthtPaperContainer}>
              <Grid item>

                <Button
                  variant="outlined"
                  className={styles.buttons}
                  color="primary"
                  style={{ marginRight: '10px' }}
                  onClick={() => handleDownloadAppointmentDetails()}
                  disabled={isDone}
                >
                  Descargar Detalles
                </Button>
                <Button
                  variant="outlined"
                  className={styles.buttons}
                  color="primary"
                  style={{ marginRight: '10px' }}
                  onClick={() => handleDownloadAppointmentConsentFile()}
                  disabled={isDone || appointment.consent_file == null}
                >
                  Descargar Consentimiento
                </Button>
                {!isProfessional && !isAssistant && (
                  <Button
                    variant="outlined"
                    className={styles.buttons}
                    color="primary"
                    style={{ marginRight: '10px' }}
                    onClick={() => setAttachmentModalOpen(true)}
                    disabled={isDone}
                  >
                    Adjuntar estudios
                  </Button>
                )}
                {/* {!isProfessional && !isAssistant && ( */}
                <Button
                  variant="outlined"
                  className={styles.buttons}
                  color="primary"
                  style={{ marginRight: '10px' }}
                  onClick={() => setSeeAttachmentsModalOpen(true)}
                  disabled={isDone}
                >
                  Ver adjuntos
                </Button>
                {/* // )} */}
                <Button
                  variant="outlined"
                  className={styles.buttons}
                  color="primary"
                  onClick={() => setCancelAppointmentModal(true)}
                  disabled={isAssistant || isDone}
                >
                  Cancelar consulta
                </Button>
                {isProfessional && (
                  <Button
                    variant="contained"
                    className={styles.buttons}
                    color="primary"
                    onClick={() => {
                      let pageName;

                      pageName =
                        process.env.REACT_APP_VIDEO_URL +
                        'appointment/' +
                        appointment.id +
                        '/?idUser=' +
                        session.id +
                        '&token=' +
                        session.accessToken +
                        '&light=1';

                      window.location.href = pageName;
                    }}
                  >
                    Aceptar e ir
                  </Button>
                )}
              </Grid>

              <Grid style={{ marginTop: '10px' }}>
                {!isProfessional && (
                  <Button
                    variant="contained"
                    className={styles.buttons}
                    color="primary"
                    onClick={handleUpdateAppointment}
                    disabled={isAssistant || isDone}
                  >
                    Guardar
                  </Button>
                )}
              </Grid>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

const mapStateToProps = ({ session, user, appointments }) => {
  return {
    session,
    userData: user,
    appointmentsData: appointments,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUser: (type, id) =>
    dispatch({
      type: userActionsTypes.GET_USER,
      payload: { type, id },
    }),
  addUserInfo: (type, data, newValue) =>
    dispatch({
      type: userActionsTypes.ADD_INFO_USER,
      payload: { type, data, newValue },
    }),
  createInfo: (type, body, data) =>
    dispatch({
      type: userActionsTypes.CREATE_INFORMATION,
      payload: { type, body, data },
    }),
  deleteUserInfo: (type, data, valueId) =>
    dispatch({
      type: userActionsTypes.DELETE_INFO_USER,
      payload: { type, data, valueId },
    }),
  updateAppointment: (body) =>
    dispatch({
      type: appointmentActionsTypes.UPDATE_APPOINTMENT,
      payload: {
        body,
      },
    }),
  updateAppointmentLight: (id, body) =>
    dispatch({
      type: appointmentActionsTypes.UPDATE_APPOINTMENT_LIGHT,
      payload: { id, body },
    }),
  uploadAppointmentFiles: (body) =>
    dispatch({
      type: appointmentActionsTypes.UPLOAD_APPOINTMENT_FILES,
      payload: { body },
    }),
  deleteAppointment: (appointmentId) =>
    dispatch({
      type: appointmentActionsTypes.DELETE_APPOINTMENT,
      payload: {
        appointmentId,
      },
    }),
  deleteAppointmentFile: (fileId) =>
    dispatch({
      type: appointmentActionsTypes.DELETE_APPOINTMENT_FILE,
      payload: {
        fileId,
      },
    }),
  deleteAttachmentMessages: () =>
    dispatch({
      type: appointmentActionsTypes.DELETE_ATTACHMENT_MESSAGES,
    }),
  getAppointmentPDF: (appointmentId, appointmentDate) =>
    dispatch({
      type: appointmentActionsTypes.GET_APPOINTMENT_PDF_DETAILS,
      payload: {
        appointmentId,
        appointmentDate,
      },
    }),
  getAppointmentConsentFile: (appointmentId, appointmentDate) =>
    dispatch({
      type: appointmentActionsTypes.GET_APPOINTMENT_CONSENT_FILE,
      payload: {
        appointmentId,
        appointmentDate,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentDetails);
